export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILED = "REGISTER_FAILED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOADING = "LOADING";
export const HANDLE_CHANGE = "HANDLE_CHANGE";
export const HANDLE_CLOSE = "HANDLE_CLOSE";
export const HANDLE_ERRORS = "HANDLE_ERRORS";
export const CLEAR_USER = "CLEAR_USER";
export const NEW_TOOL_FAILED = "NEW_TOOL_FAILED";
export const NEW_TOOL_ADDED = "NEW_TOOL_ADDED";
export const GET_TOOLS_SUCCESS = "GET_TOOLS_SUCCESS";
export const GET_TOOLS_ERROR = "GET_TOOLS_ERROR";
export const SET_PAGINATION = "SET_PAGINATION";
export const HANDLE_TOOL_CHANGE = "HANDLE_TOOL_CHANGE";
export const CLEAR_TOOL = "CLEAR_TOOL";
export const IMAGE_UPLOAD_SUCCESS = "IMAGE_UPLOAD_SUCCESS";
export const IMAGE_UPLOAD_FAILED = "IMAGE_UPLOAD_FAILED";
export const HANDLE_FILE_CHANGE = "HANDLE_FILE_CHANGE";
export const HANDLE_MODAL_OPEN = "HANDLE_MODAL_OPEN";
export const HANDLE_MODAL_CLOSE = "HANDLE_MODAL_CLOSE";
export const HANDLE_MODAL_UPLOAD_OPEN = "HANDLE_MODAL_UPLOAD_OPEN";
export const HANDLE_MODAL_UPLOAD_CLOSE = "HANDLE_MODAL_UPLOAD_CLOSE";
export const HANDLE_UPLOAD_ID = "HANDLE_UPLOAD_ID";
export const GET_ONE_TOOL_FAILED = "GET_ONE_TOOL_FAILED";
export const GET_ONE_TOOL_SUCCESS = "GET_ONE_TOOL_SUCCESS";
export const GET_MY_TOOLS_SUCCESS = "GET_MY_TOOLS_SUCCESS";
export const DELETE_TOOL_SUCCESS = "DELETE_TOOL_SUCCESS";
export const POPULATE_FORM = "POPULATE_FORM";
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS";
export const GET_ALL_PROFILES_SUCCESS = "GET_ALL_PROFILES_SUCCESS";
export const CHANGE_THEME = "CHANGE_THEME";
export const HANDLE_SEARCH_CHANGE = "HANDLE_SEARCH_CHANGE";
export const GET_RENTED_TOOLS_SUCCESS = "GET_RENTED_TOOLS_SUCCESS";
export const PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";
export const PASSWORD_RESET_FAILED = "PASSWORD_RESET_FAILED";
